import React from 'react';
import { EditFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';

interface IProps {
  tooltip?: string;
  onClick?: () => void;
  style?: React.CSSProperties | undefined;
  className?: string | undefined;
}

const EditIcon = ({ tooltip, onClick, style, className }: IProps) => {
  return (
    <Tooltip title={tooltip}>
      <EditFilled
        onClick={onClick}
        style={{ color: '#faad14', fontSize: 16, ...style }}
        className={className}
      />
    </Tooltip>
  );
};

export default EditIcon;
